import React from "react";
import AllSite from "../component/sections/site/AllSite";
import AddSite from "../component/sections/site/AddSite";
import InfoSite from "../component/sections/site/InfoSite";

const sitesRoutes = [
  {
    path: "/site/all",
    render: () => <AllSite />,
    exact: true,
  },
  {
    path: "/site/add",
    render: () => <AddSite />,
    exact: true,
  },
  {
    path: "/site/info/:sitePublisherID",
    render: () => <InfoSite />,
    exact: true,
  },
];

export default sitesRoutes;
